export const placeholder = {
  value: 'Value',
  search: 'Search',
  date: {
    start: 'Start date',
    stop: 'End date',
    end: 'End date',
    from: 'From',
    to: 'To'
  },
  time: {
    start: 'Start time',
    stop: 'End time',
    from: 'From',
    to: 'To'
  }
}

export const word = {
  input: 'input',
  server: 'server',
  list: 'list',
  member: 'list member',
  members: 'list members',
  preprocessor: 'preprocessor',
  processor: 'processor',
  postprocessor: 'postprocessor',
  output: 'output',
  information: 'information',
  current: 'current',
  user: 'user',
  users: 'users',
  license: 'license',
  notification: 'notification',
  logs: 'logs',
  active: 'active',
  inactive: 'inactive',
  loading: 'Loading',
  cancel: 'Cancel',
  live: 'Live',
  of: 'of'
}

export const title = {
  notifications: 'Notifications'
}

export const error = {
  validation: 'Validation error'
}
